<template>
  <v-container
    class="vpd-content"
    v-if="!showResult"
    key="confirm-otp"
    fluid
  >
    <v-overlay :value="overlay" z-index="1000">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>

    <vpd-confirm-otp-panel
      @submit="submitOtp"
      ref="otpPanel"
    ></vpd-confirm-otp-panel>
  </v-container>

  <v-container class="vpd-content" v-else key="confirm-otp-result">
    <vpd-notification-panel
      :alertText="alertText"
      alertType="success"
      buttonRoute="/accounts"
      buttonText="Tovább a fiókhoz"
    />
  </v-container>
</template>

<script>
import VpdConfirmOtpPanel from "../components/auth/vpd-confirm-otp-panel/vpd-confirm-otp-panel";
import VpdNotificationPanel from "../components/vpd-notification-panel/vpd-notification-panel";
import { Auth, confirmSignIn, getCurrentUser, fetchAuthSession } from "@aws-amplify/auth";
import { AmplifyEventBus } from "aws-amplify-vue";

const alertText = "A bejelentkezés sikeres volt!";

export default {
  name: "confirm-otp",
  components: {
    VpdConfirmOtpPanel,
    VpdNotificationPanel,
  },
  data: () => ({
    showResult: false,
    overlay: false,
    alertText: "",
  }),
  methods: {
    async submitOtp(code) {
        const panel = this.$refs.otpPanel;
        this.overlay = true;

        try {
            const user = await getCurrentUser();

            // ✅ new Amplify v6 confirmSignIn signature:
            const { isSignedIn, nextStep } = await confirmSignIn({
            challengeResponse: code,
            });

            if (isSignedIn) {
            await fetchAuthSession(); // refresh tokens
            AmplifyEventBus.$emit("authState", "signedIn");
            this.showResult = true;
            } else {
            console.warn("Next step:", nextStep);
            panel.showAlert("További azonosítás szükséges!", "warning");
            }
        } catch (error) {
            console.error("❌ OTP error:", error);
            panel.showAlert("Érvénytelen vagy lejárt kód!", "error");
        } finally {
            this.overlay = false;
        }
    },
  },
  created() {
    this.alertText = alertText;
  },
};
</script>
